var _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpensource = function SvgOpensource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 143 138",
    style: {
      enableBackground: "new 0 0 143 138"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "opensource_svg__a",
    d: "M0 0h143v138H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "opensource_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#opensource_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#opensource_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1 93.6c12.4-4.7 18.5-18.5 13.8-30.9-4.7-12.3-18.6-18.5-31-13.7-12.4 4.7-18.5 18.5-13.8 30.9 2.4 6.4 7.5 11.3 13.8 13.7l-16.1 41.9C11.2 121.9-6.6 82.1 7.1 46.6S60.6-6.5 96.2 7c35.5 13.6 53.3 53.4 39.7 88.9-7 18.2-21.4 32.6-39.7 39.6L80.1 93.6z",
    style: {
      fill: "#1ed760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2 138c-1 0-1.9-.6-2.3-1.6L77.8 94.5c-.5-1.3.1-2.7 1.4-3.2 5.4-2 9.6-6 11.9-11.3 2.4-5.2 2.5-11.1.4-16.4C87.2 52.5 74.8 47 63.7 51.3 52.7 55.6 47.1 68 51.4 79c2.2 5.7 6.7 10.2 12.4 12.3 1.3.5 1.9 1.9 1.4 3.2L49 136.4c-.5 1.3-1.9 1.9-3.2 1.4C28 131 13.9 117.7 6.2 100.3c-7.8-17.4-8.3-36.8-1.4-54.6C11.6 28 25 14 42.4 6.2 59.9-1.5 79.3-2 97.1 4.8c17.8 6.8 31.9 20.1 39.7 37.5 7.8 17.4 8.3 36.8 1.4 54.6-7.3 18.8-22.2 33.8-41.1 41-.3 0-.6.1-.9.1zM71.5 5c-9.2 0-18.4 1.9-27 5.8C28.2 18 15.8 31 9.4 47.6 3 64.2 3.5 82.1 10.7 98.3c6.9 15.4 19.1 27.4 34.7 34l14.4-37.4c-5.9-2.9-10.6-8-12.9-14.2-5.2-13.6 1.6-28.8 15.2-34 13.6-5.2 28.9 1.6 34.1 15.2 2.5 6.5 2.4 13.7-.5 20.1-2.5 5.7-6.9 10.2-12.4 12.9l14.4 37.4c16.5-7 29.6-20.4 36-37.2 6.4-16.5 5.9-34.5-1.3-50.7-7.2-16.2-20.4-28.6-37-34.9C87.6 6.4 79.5 5 71.5 5z",
    style: {
      fill: "#1d531d"
    }
  })));
};

export default SvgOpensource;